import { HistoricalConversation } from "@buzzeasy/shared-frontend-utilities";
import { ExpandedHistoricalWorkItemDto, InternalHistoricalConversation, InternalHistoricalWorkItem } from "../../dashboard/models/reports.historical";

export function mapToInternalHistoricalWorkItem(external: ExpandedHistoricalWorkItemDto): InternalHistoricalWorkItem {
  return {
    ...external,
    isOutbound: external.conversations.find(c => c.id === external.primaryConversationId)?.isOutbound ?? true,
    startTimeUtc: new Date(external.startTimeUtc),
    endTimeUtc: new Date(external.endTimeUtc),
    conversations: external.conversations.map(mapToInternalHistoricalConversation),
  };
}

function mapToInternalHistoricalConversation(external: HistoricalConversation): InternalHistoricalConversation {
  const ext = external;

  return {
    ...ext,
    startedAtUtc: new Date(ext.startedAtUtc),
    endedAtUtc: new Date(ext.endedAtUtc),
    customerIdentifier: ext.customerEmailAddress ?? ext.customerPhoneNumber ?? ext.identifiedCustomerEmailAddress ?? undefined,
    customer: ext.customerId
      ? {
          id: ext.customerId,
          firstName: ext.customerFirstName ?? "",
          middleName: ext.customerMiddleName ?? "",
          lastName: ext.customerLastName ?? "",
          emailAddress: ext.customerEmailAddress,
          phoneNumber: ext.customerPhoneNumber,
          identifiedEmailAddress: ext.identifiedCustomerEmailAddress,
        }
      : undefined,
  };
}
